import React from "react";
import EasterEgg from "./EasterEgg";
import Frame from "./Frame";
import SidebarButton from "./SidebarButton";
import Content from "./Content";

interface HeroProps {
  isSidebarOpen: boolean;
  onToggleSidebar: () => void;
}

const Hero = ({ isSidebarOpen, onToggleSidebar }: HeroProps) => (
  <Frame>
    <EasterEgg />
    <SidebarButton isOpen={isSidebarOpen} onClick={onToggleSidebar} />
    <Content />
  </Frame>
);

export default Hero;
